import * as geoJsonMap from './geo.json';
export default geoJsonMap;
